import React from 'react'

import {
  PublicWorkspaceFragment,
  WorkspaceMinimalFragment,
} from '@sketch/gql-types'
import { isPersonalWorkspace } from 'modules/workspace/utils'
import {
  StyledBadge,
  StyledWorkspaceIcon,
  StyledHamburgerIcon,
} from './HeaderWorkspaceBadge.styles'
import { useForTablet, ButtonUnstyled } from '@sketch/components'

export interface HeaderWorkspaceBadgeProps {
  workspace: PublicWorkspaceFragment | WorkspaceMinimalFragment
  setSidebarLeftOpen?: React.Dispatch<React.SetStateAction<boolean>>
}

const HeaderWorkspaceBadge: React.FC<HeaderWorkspaceBadgeProps> = ({
  workspace,
  setSidebarLeftOpen,
}) => {
  const isTabletAndBigger = useForTablet()
  const isSmallerThanTablet = !isTabletAndBigger
  const openSidebar = () => setSidebarLeftOpen?.(true)

  if (isSmallerThanTablet) {
    return <StyledHamburgerIcon onClick={openSidebar}></StyledHamburgerIcon>
  }

  return isPersonalWorkspace(workspace) ? (
    <ButtonUnstyled onClick={openSidebar}>
      <StyledWorkspaceIcon icon="briefcase" size="24px" />
    </ButtonUnstyled>
  ) : (
    <ButtonUnstyled onClick={openSidebar}>
      <StyledBadge
        workspaceName={workspace.name}
        src={workspace.avatar?.large}
        size="24px"
      />
    </ButtonUnstyled>
  )
}

export default HeaderWorkspaceBadge
